
import React, { useContext, useEffect, useState } from "react";
import { LanguageContext } from "../context/LanguageContext";  // 確保路徑正確
import { NavLink, useLocation } from 'react-router-dom'; // React Router NavLink 和 useLocation
import LogoSwitcher from '../LogoSwitcher'; // 假設使用之前的 Logo 切換邏輯


const Navbar = () => {
  const { componentLanguageData, loadLanguageFile, language, changeLanguage } = useContext(LanguageContext);
  const [isOpen, setIsOpen] = useState(false); // 控制語言選單是否開啟

  useEffect(() => {
    loadLanguageFile("Navbar", "Navbar_lang");
  }, [language]);

  const LANGUAGE = componentLanguageData.Navbar || { Main: {} };
  const location = useLocation();

  // 根據路徑設置標題
  const pageTitle =
    location.pathname === '/'
      ? LANGUAGE.Main.Content1
      : LANGUAGE.Main.Content2;

  // 語系對照表，用於傳遞給外部登入註冊系統
  const langQueryMap = {
    "zh-TW": "zh-TW",
    "zh-CN": "zh-CN",
    "en": "en-US",
    "en-GB": "en-GB"
  };

  const getUrlWithLang = (baseUrl) => {
    if (!baseUrl) return "#";
    const mappedLang = langQueryMap[language] || "en-US";
    return `${baseUrl}${baseUrl.includes('?') ? '&' : '?'}lang=${mappedLang}`;
  };

  return (
    <div className="container-fluid position-relative p-0">
      <nav className="navbar  navbar-expand-lg navbar-dark px-5 py-3 py-lg-0">
        <a href="/" className="navbar-brand p-0">
          <h1 className="m-0">
            <LogoSwitcher />
            {pageTitle}
          </h1>
        </a>
        <button
          className="navbar-toggler"
          type="button"
          data-bs-toggle="collapse"
          data-bs-target="#navbarCollapse"
        >
          <span className="fa fa-bars"></span>
        </button>
        <div className="collapse navbar-collapse" id="navbarCollapse">
          <div className="navbar-nav ms-auto py-0">
            {/* 使用 NavLink 確保 active 狀態 */}
            <NavLink
              to="/"
              className={({ isActive }) =>
                `nav-item nav-link ${isActive ? 'active' : ''}`
              }
            >
              {LANGUAGE.Main.Content3}
            </NavLink>
            <div className="nav-item dropdown">
              <a
                href="#"
                className="nav-link dropdown-toggle"
                data-bs-toggle="dropdown"
                aria-expanded="false"
              >
                {LANGUAGE.Main.Content10}
              </a>
              <div className="dropdown-menu m-0">
                <a
                  href={LANGUAGE.Main.Content22}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="dropdown-item"
                >
                  {LANGUAGE.Main.Content23}
                </a>
                <NavLink
                  to="/product_ai"
                  className={({ isActive }) =>
                    `dropdown-item ${isActive ? 'active' : ''}`
                  }
                >
                  {LANGUAGE.Main.Content11}
                </NavLink>
                <NavLink
                  to="/product_lib"
                  className={({ isActive }) =>
                    `dropdown-item ${isActive ? 'active' : ''}`
                  }
                >
                  {LANGUAGE.Main.Content12}
                </NavLink>
                <NavLink
                  to="/product_download"
                  className={({ isActive }) =>
                    `dropdown-item ${isActive ? 'active' : ''}`
                  }
                >
                  {LANGUAGE.Main.Content18}
                </NavLink>
                <NavLink
                  to={LANGUAGE.Main.Content17}
                  target="_blank"
                  className={({ isActive }) =>
                    `dropdown-item ${isActive ? 'active' : ''}`
                  }
                >
                  {LANGUAGE.Main.Content14}
                </NavLink>
                <NavLink
                  to="/outsourcing"
                  className={({ isActive }) =>
                    `dropdown-item ${isActive ? 'active' : ''}`
                  }
                >
                  {LANGUAGE.Main.Content15}
                </NavLink>

              </div>
            </div>
            <a
              href={LANGUAGE.Main.Content22}
              target="_blank"
              rel="noopener noreferrer"
              className="nav-item nav-link"
            >
              {LANGUAGE.Main.Content21}
            </a>
            <div className="nav-item dropdown">
              <a
                href="#"
                className="nav-link dropdown-toggle"
                data-bs-toggle="dropdown"
                aria-expanded="false"
              >
                {LANGUAGE.Main.Content4}
              </a>
              <div className="dropdown-menu m-0">
                <NavLink
                  to="/about"
                  className={({ isActive }) =>
                    `dropdown-item ${isActive ? 'active' : ''}`
                  }
                >
                  {LANGUAGE.Main.Content6}
                </NavLink>
                <NavLink
                  to="/team"
                  className={({ isActive }) =>
                    `dropdown-item ${isActive ? 'active' : ''}`
                  }
                >
                  {LANGUAGE.Main.Content8}
                </NavLink>
              </div>
            </div>
            <NavLink
              to="/partners"
              className={({ isActive }) =>
                `nav-item nav-link ${isActive ? 'active' : ''}`
              }
            >
              {LANGUAGE.Main.Content13}
            </NavLink>
            <NavLink
              to="/pricing"
              className={({ isActive }) =>
                `nav-item nav-link ${isActive ? 'active' : ''}`
              }
            >
              {LANGUAGE.Main.Content19}
            </NavLink>
            {/* <NavLink
              to="/service"
              className={({ isActive }) =>
                `nav-item nav-link ${isActive ? 'active' : ''}`
              }
            >
              {LANGUAGE.Main.Content5}
            </NavLink> */}
            {/* <NavLink
              to="/feature"
              className={({ isActive }) =>
                `nav-item nav-link ${isActive ? 'active' : ''}`
              }
            >
              {LANGUAGE.Main.Content7}
            </NavLink> */}
            <NavLink
              to="/contact"
              className={({ isActive }) =>
                `nav-item nav-link ${isActive ? 'active' : ''}`
              }
            >
              {LANGUAGE.Main.Content9}
            </NavLink>
            <NavLink
              to={getUrlWithLang(process.env.REACT_APP_SIGNIN_URL || "https://trade.masquant.com/authentication/sign-in")}
              // target="_blank"
              // onClick={() => alert('Stay tuned')}
              className={({ isActive }) =>
                `nav-item nav-link ${isActive ? 'active' : ''}`
              }
            >
              {LANGUAGE.Main.Content20}
            </NavLink>
            <NavLink
              id="sign_in"
              to={getUrlWithLang(process.env.REACT_APP_SIGNUP_URL || "https://trade.masquant.com/authentication/sign-up")}
              // target="_blank"
              // onClick={() => alert('Stay tuned')}
              className={({ isActive }) =>
                `nav-item nav-link ${isActive ? 'active' : ''}`
              }
            >
              {LANGUAGE.Main.Content16}
            </NavLink>
            {/* <NavLink
              to="#"
              onClick={(e) => {
                e.preventDefault();
                changeLanguage();
              }}
              className="nav-item nav-link"
            >
              {language === "zh-TW" ? "English" : "中文"}
            </NavLink> */}
            <div className="nav-item dropdown">
              <a
                href="#"
                className="nav-link dropdown-toggle"
                data-bs-toggle="dropdown"
                aria-expanded="false"
              >
                {language === "zh-TW"
                  ? "繁體中文"
                  : language === "zh-CN"
                    ? "简体中文"
                    : language === "en-GB"
                      ? "EN (UK)"
                      : "EN"}
              </a>
              <div className="dropdown-menu m-0">
                <a
                  href="#"
                  className="dropdown-item"
                  onClick={(e) => {
                    e.preventDefault();
                    if (language !== "zh-TW") changeLanguage("zh-TW");
                  }}
                >
                  繁體中文
                </a>
                <a
                  href="#"
                  className="dropdown-item"
                  onClick={(e) => {
                    e.preventDefault();
                    if (language !== "zh-CN") changeLanguage("zh-CN");
                  }}
                >
                  简体中文
                </a>
                <a
                  href="#"
                  className="dropdown-item"
                  onClick={(e) => {
                    e.preventDefault();
                    if (language !== "en") changeLanguage("en");
                  }}
                >
                  EN
                </a>
                <a
                  href="#"
                  className="dropdown-item"
                  onClick={(e) => {
                    e.preventDefault();
                    if (language !== "en-GB") changeLanguage("en-GB");
                  }}
                >
                  EN (UK)
                </a>
              </div>
            </div>

          </div>
        </div>
      </nav>
    </div>
  );
};

export default Navbar;
